import { useFormikContext } from "formik";
import React, {
  forwardRef,
  Fragment,
  useEffect,
  useRef,
  useState,
} from "react";
import { getCountries, getState, getStates } from "../../../apis/locationApi";
import { getName, labelName } from "../../../utils/functions";
import ErrorMessage from "../ErrorrMessage";
import TextFieldStyles from "../TextField/TextField.module.css";
import dropdownStyles from "./Dropdown.module.css";

const DropdownList = forwardRef(
  ({ isVisible = false, data, onClick, handleClose, container }, ref) => {
    const [options, setOptions] = useState(data);

    const handleSearch = (val) => {
      const $options = [...data];
      if (val.length > 0) {
        const searchResult = $options.filter((item) =>
          typeof item === "object"
            ? item.name.toLowerCase().includes(val.toLowerCase())
            : item.toLowerCase().includes(val.toLowerCase())
        );
        setOptions(searchResult);
      } else {
        setOptions(data);
      }
    };

    const handleClick = (val, option) => {
      onClick(val, option);
      setOptions(data);
      handleClose();
    };

    const globalListner = (e) => {
      if (
        container &&
        container.current &&
        container.current.contains(e.target)
      ) {
        return;
      }
      handleClose();
    };

    useEffect(() => {
      setOptions(data);
    }, [data]);
    
    useEffect(() => {
      document.addEventListener("click", globalListner);
      return () => {
        document.removeEventListener("click", globalListner);
      };
    }, []);

    if (!isVisible) return <></>;

    return (
      <div className={dropdownStyles.dropdownList} ref={ref}>
        <input
          className={`${TextFieldStyles.input} ${dropdownStyles.dropdownListInput}`}
          type="text"
          placeholder="Search list"
          onChange={(e) => handleSearch(e.target.value)}
        />
        <div className={dropdownStyles.dropdownListItemContainer}>
          {options &&
            options.length > 0 &&
            options.map((option, index) => (
              <Fragment key={`${option}-${index}`}>
                {typeof option === "string" && (
                  <button
                    className={dropdownStyles.dropdownListItem}
                    type="button"
                    onClick={() => handleClick(option)}
                  >
                    {option}
                  </button>
                )}
                {typeof option === "object" && (
                  <button
                    className={dropdownStyles.dropdownListItem}
                    type="button"
                    onClick={() => handleClick(option.name, option)}
                  >
                    {option.name}
                  </button>
                )}
              </Fragment>
            ))}
        </div>
      </div>
    );
  }
);

export default function Dropdown({ field_label, field_items, parent }) {
  const { getFieldProps, setFieldValue, values } = useFormikContext();

  const [countries, setCountries] = useState(null);
  const [states, setStates] = useState(null);

  const [laoding, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const inputRef = useRef();
  const dropdownRef = useRef();

  const selectedCountryTokenPointer = btoa('selected_country_token');

  const handleChangeCountry = function (element, countryName, countryObject){
    setFieldValue(element, countryName);
    window.localStorage.setItem(selectedCountryTokenPointer, countryObject.token);
  }

  let filteredFieldItems = [];
  if (parent == null) {
    filteredFieldItems = field_items;
  } else {
    filteredFieldItems = field_items?.filter(
      (item) => item.parent == values[parent]
    );
  }

  const name = field_label.includes("country")
    ? getName(parent, "country")
    : field_label.includes("state")
    ? getName(parent, "state")
    : getName(parent, field_label);
    
  const country = parent
    ? values[parent]?.["fields"]?.["country"]
    : values["country"];

  const fetchCountries = async () => {
    setLoading(true);
    const result = await getCountries();
    setLoading(false);
    if (!result.ok) {
      console.log(result.originalError.message);
    }
    setCountries(result?.data?.countries);
  };

  const fetchStates = async (countryToken) => {
    setLoading(true);
    const result = await getStates({ countryToken });
    setLoading(false);
    if (!result.ok) {
      console.log(result.originalError.message);
    }
    setStates(result.data.states);
  };

  // const countriesSelect = () => {
  //   states.map((country, index) => ({ name: country.name }));
  // };

  useEffect(() => {
    if (field_label.includes("country")) {
      return fetchCountries();
    }
  }, []);

  useEffect(() => {
    if (!field_label.includes("state") || !country) return;

    const countryToken = window.localStorage.getItem(selectedCountryTokenPointer);
    if(!countryToken) return;

    window.localStorage.removeItem(selectedCountryTokenPointer);
    return fetchStates(countryToken);
  }, [country]);

  return (
    <div
      className={`${TextFieldStyles.inputContainer} ${dropdownStyles.dropdownContainer}`}
    >
      <label className={TextFieldStyles.label}>
        {labelName(field_label)} {laoding && <small>Loading...</small>}
      </label>
      <div ref={inputRef}>
        <input
          type="text"
          className={TextFieldStyles.input}
          placeholder={`Select - ${labelName(field_label)}`}
          onClick={() => setIsVisible(true)}
          {...getFieldProps(name)}
          readOnly
        />

        {!field_items && states && (
          <DropdownList
            ref={dropdownRef}
            isVisible={isVisible}
            handleClose={() => setIsVisible(false)}
            container={inputRef}
            data={states}
            onClick={(val) => setFieldValue(name, val)}
          />
        )}

        {!field_items && countries && (
          <DropdownList
            ref={dropdownRef}
            isVisible={isVisible}
            handleClose={() => setIsVisible(false)}
            container={inputRef}
            data={countries}
            onClick={(val, option) => handleChangeCountry(name, val, option)}
          />
        )}
        {!countries && field_items && (
          <DropdownList
            ref={dropdownRef}
            isVisible={isVisible}
            handleClose={() => setIsVisible(false)}
            container={inputRef}
            data={filteredFieldItems}
            onClick={(val) => setFieldValue(name, val)}
          />
        )}
      </div>

      <ErrorMessage name={name} parent={parent} />
    </div>
  );
}
